import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CategoryIcon from '@mui/icons-material/Category';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './Item.css';

const ItemCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState('');
    const [gstRate, setGstRate] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    const submitData = (e) => {
        e.preventDefault();
        if (!name) { setErrorMessage('Name is required!'); return; }
        postData('CategoryApi', { Name: name, GSTRate: gstRate, CreatedBy: userId, CompanyId: companyId, CreatedDate: new Date() }, token)
            .then(() => {
                setSuccessMessage('Item created successfully!');
                setErrorMessage('');
                history.push('/ItemIndex');
            })
            .catch((e) => { console.error('Item Create error:', e); setErrorMessage('Error creating item.'); });
    };

    return (
        <div className="item-container">
            <div className="item-header-card">
                <div className="item-header-content">
                    <div className="item-title-section">
                        <span className="item-title-icon"><CategoryIcon fontSize="small" /></span>
                        <h1 className="item-title">Item Create</h1>
                    </div>
                    <div className="item-header-actions">
                        <button className="it-btn it-btn-save" onClick={submitData}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Save
                        </button>
                        <Link to="/ItemIndex" className="it-btn it-btn-back">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Back
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="item-alert item-alert-error">{errorMessage}</div>}
            {successMessage && <div className="item-alert item-alert-success">{successMessage}</div>}

            <div className="item-form-card">
                <p className="item-form-section-title">Item Information</p>
                <div className="item-form-row">
                    <div className="item-form-group w-3">
                        <label className="item-label">Item Name <span className="required">*</span></label>
                        <input className="item-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter item name" required maxLength={50} />
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">GST Rate</label>
                        <input className="item-input text-right" type="number" value={gstRate} onChange={(e) => setGstRate(e.target.value)} placeholder="0" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemCreate;
